// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__32SKT","bigColWidth":"Table_bigColWidth__3tGzc","biggerColWidth":"Table_biggerColWidth__39Z5c","row":"Table_row__33-2v","col":"Table_col__1BFys"};